export const getMenuData = [
  // *****************************
  // *****************************
  // CATÁLOGOS
  {
    category: true,
    title: 'Catálogos',
    key: 'q7r3hr',
    roles: ['SUPER ADMIN'],
  },
  {
    title: 'Catálogos',
    key: '__catalogs',
    url: '/catalogos',
    icon: 'fe fe-grid',
    roles: ['SUPER ADMIN'],
    children: [
      {
        title: 'Principal',
        key: 'cat_main',
        url: '/catalogos/principal',
        roles: ['SUPER ADMIN'],
      },
      {
        title: 'Catálogo de Razón Social',
        key: 'cat_business_name',
        url: '/catalogos/razon_social',
        roles: ['SUPER ADMIN'],
      },
      {
        title: 'Catálogo Unidades de Negocio',
        key: 'cat_business_units',
        url: '/catalogos/unidad_negocio',
        roles: ['SUPER ADMIN'],
      },
      {
        title: 'Catálogo Leyendas Carta Porte',
        key: 'cat_consignment_settings',
        url: '/catalogos/leyenda_carta',
        roles: ['SUPER ADMIN'],
      },
      {
        title: 'Catálogo de Plantas',
        key: 'cat_plants',
        url: '/catalogos/plantas',
        roles: ['SUPER ADMIN'],
      },
      {
        title: 'Catálogo de Puestos de Empleados',
        key: 'cat_positions',
        url: '/catalogos/puestos_empleados',
        roles: ['SUPER ADMIN'],
      },
      {
        title: 'Catálogos de Usuarios',
        key: 'cat_users',
        url: '/catalogos/usuarios',
        roles: ['SUPER ADMIN'],
      },
    ],
  },
  // CATÁLOGOS
  // *****************************
  // *****************************

  // *****************************
  // *****************************
  // HISTORIAL
  {
    category: true,
    title: 'Historial',
    key: 'q7r3hh',
  },
  {
    title: 'Historial',
    key: '__consignment_note',
    url: '/carta_porte',
    icon: 'fe fe-file-text',
    children: [
      {
        title: 'Principal',
        key: 'consignment_note_main',
        url: '/carta_porte/principal',
      },
    ],
  },
  // HISTORIAL
  // *****************************
  // *****************************

]
